import './App.css'
import List from './List';
import useSemiPersistentState from './useSemiPersistentState';
import {useEffect, useReducer, useCallback, useState} from 'react'
import Logo from './ReactLogo.png';
import axios from 'axios';
import SearchForm from './SearchForm';

const API_ENDPOINT = 'https://hn.algolia.com/api/v1/search?query=';

const storyReducer = (state, action) => {
  switch(action.type) {
  case 'STORIES_FETCH_INIT': 
    return {
      ...state,
      isLoading: true,
      isError: false,
    };
  case 'STORIES_FETCH_SUCCESS': 
    return {
      ...state,
      isLoading: false,
      isError: false,
      data: action.payload,
    };
  case 'STORIES_FETCH_FAILURE':
    return {
      ...state,
      isLoading: false,
      isError: true,
    };
  case 'REMOVE_STORIES':
    return {
      ...state,
      data: state.data.filter(
      story => action.payload.objectID !== story.objectID
    ),
      };
  default:
    throw new Error();
  }
};

const App = () => {
    
  const [searchTerm, setSearchTerm] = useSemiPersistentState('', '');
  const [url, setUrl] = useState(`${API_ENDPOINT}${searchTerm}`);
  const [stories, dispatchStories] = useReducer(storyReducer, {data: [], isLoading: false, isError: false});
  const [highlightedStories, setHighlightedStories] = useState([]);

    const handleFetchStories = useCallback(() => {

    dispatchStories({type: 'STORIES_FETCH_INIT'});
    axios.get(url)
    .then(result => {
      dispatchStories({
        type: 'STORIES_FETCH_SUCCESS',
        payload: result.data.hits,
      });
    })
    .catch(() => 
    dispatchStories({type: 'STORIES_FETCH_FAILURE'})
    );
  }, [url]);
 
useEffect(() => {
    handleFetchStories();}, [handleFetchStories])

  const handleRemoveStory = item => {
    dispatchStories({
      type: 'REMOVE_STORIES',
      payload: item,
    });
  };

  const handleSearchInput = event => {
    setSearchTerm(event.target.value);
    };

  const handleSearchSubmit = event => {
    setUrl(`${API_ENDPOINT}${searchTerm}`)
    event.preventDefault();
  };

  const highlightStory = objectID => {
    setHighlightedStories([...highlightedStories, objectID])
  }

  const removeHighlight = objectID => {
    const newHighlights = highlightedStories.filter(highlightedstory => objectID !== highlightedstory) 
    setHighlightedStories(newHighlights);
  }

    
  return (
    <div>
      <p><img src={Logo} alt="React Logo" className="Logo"/></p>
      <h1>Some Hacker Stories</h1>
      <SearchForm searchTerm={searchTerm} onSearchInput={handleSearchInput} onSearchSubmit={handleSearchSubmit}/>
      {stories.isError && <p>I'm afraid something went wrong...</p>}
      <div className="container">
      {stories.isLoading ? (<p className="loading">The hacker stories are loading</p>) : 
      (<List stories={stories.data} onRemoveItem={handleRemoveStory} onHighlight={highlightStory} highlightedStories={highlightedStories} onRemoveHighlight={removeHighlight}/>)}
      </div>      
      <footer><p>This is a React app based on Robin Wieruch's teaching. It uses the Hacker News api to display, search, delete and highlight stories.</p>
      <p>Icons made by <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p></footer>
      </div>
  )
};

export default App;
